var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useMemo } from "react";
import styled from "styled-components";
import { useTableDispatch } from "./context";
var Cell = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, rowStart = _a.rowStart, selected = _a.selected;
    return "\n    display: flex;\n    align-items: center;\n    grid-row-start: ".concat(rowStart, ";\n    white-space: nowrap;\n    background-color: ").concat(selected ? "red" : rowStart % 2 === 1 ? theme.bgContent() : theme.bgContent2(), ";\n    padding: 0rem .5rem;\n  ");
});
export var TableCell = function (_a) {
    var value = _a.value, _b = _a.rowStart, rowStart = _b === void 0 ? 0 : _b, selected = _a.selected;
    var tableDispatch = useTableDispatch();
    var currVal = useMemo(function () {
        return value;
    }, [value]);
    var handleClick = useCallback(function () {
        tableDispatch({ type: "TOGGLE_ROW_SELECT", payload: { rowStart: rowStart } });
    }, [rowStart, tableDispatch]);
    return (React.createElement(Cell, { onClick: handleClick, rowStart: rowStart, selected: selected }, currVal));
};
var templateObject_1;
